var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.165,
    height: 77.834,
    viewBox: "0 0 73.165 77.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122548",
    "data-name": "Group 122548",
    transform: "translate(726.21 -22365.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171722",
    "data-name": "Path 171722",
    d: "M307.428,217.459l9.353,3.412c-3.292,2.191-18.036-1.383-21.991-5.731l9.446,1.482c1.081-3.962,2.334-8,3.186-12.121.183-.889-.878-2.293-1.715-3.093-4.307-4.112-5.547-8.97-3.5-14.49,2.873-7.762,6.01-15.426,8.932-23.17.893-2.367,2.088-2.7,4.557-2.1,12.851,3.1,12.855,3.008,10.772,16.068-.781,4.9-1.414,9.822-2.183,14.723-.813,5.187-3.538,9.249-8.693,10.354-4.189.9-5.655,3.188-6.294,6.888-.42,2.427-1.14,4.8-1.866,7.777m3.993-46.136c7.558,3.388,13.363,1.548,12.979-3.974-10.6-3.979-10.926-3.89-12.979,3.974",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171723",
    "data-name": "Path 171723",
    d: "M367.955,217.209l-21.7,5.882-.7-2.164,9.353-3.588c-1.077-3.994-1.957-8.006-3.331-11.84-.35-.977-2.193-1.678-3.479-2.018-5.779-1.524-9.027-5.222-9.957-11.046-1.254-7.859-2.433-15.731-3.747-23.581-.469-2.8.3-4.061,3.275-4.866,12.084-3.269,12.049-3.4,16.689,8.3,1.895,4.78,3.771,9.569,5.69,14.34,2.1,5.211,1.13,10-2.862,13.675-2.484,2.285-3.242,4.3-1.921,7.285a10.315,10.315,0,0,1,.8,2.872c.633,5.13,2.793,7.53,8.172,4.984.9-.425,2.173-.06,3.274-.06l.447,1.823m-17.206-44.68c-1.338-7.837-7-9.958-12.359-5.438a3.368,3.368,0,0,0-.783,2.992c.35.981,1.541,2.262,2.455,2.336,3.4.276,6.839.11,10.687.11",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171724",
    "data-name": "Path 171724",
    d: "M330.507,153.573v-8.316l1.4.02V153.4l-1.4.168",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171725",
    "data-name": "Path 171725",
    d: "M335.129,158.1l7.125-4.369q.574.9,1.151,1.808L336.511,160l-1.382-1.9",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171726",
    "data-name": "Path 171726",
    d: "M326.173,160.122l-7.166-4.51,1.2-1.973,7.226,4.288-1.258,2.195",
    transform: "translate(-1021 22220)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheers);
export default __webpack_public_path__ + "static/media/cheers.c748d312762a84de12a6f8293d1abfdb.svg";
export { ForwardRef as ReactComponent };